'use strict';

packagesService.$inject = ["$http"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.packagesService = packagesService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function packagesService($http) {
    //, PackageItem
    return {
        getRecentOrders: getRecentOrders,
        getOrders: getOrders,
        getOrderTypes: getOrderTypes,
        getPackageTypes: getPackageTypes,
        validateContact: validateContact,
        getStateHistory: getStateHistory,
        getById: getById,
        getContactTypeName: getContactTypeName,
        getOrderStateContext: getOrderStateContext,
        getOrderStateIcon: getOrderStateIcon
    };

    function getContactTypeName(id) {
        var urlString = '/assets/data/packages.json';

        return $http.get(urlString).then(function (response) {
            var orderType = response.data.orderTypes.find(function (i) {
                return i.id === id;
            });
            return orderType ? orderType.name : null;
        });
    }

    function getOrderStateContext(code) {
        var context = void 0;

        switch (code) {
            case 'READY':
                context = 'secondary';
                break;
            case 'PICKEDUP':
                context = 'info';
                break;
            case 'DEPOT':
                context = 'info';
                break;
            case 'TRANSIT':
                context = 'info';
                break;
            case 'DELIVERED':
                context = 'success';
                break;
            case 'SIGNED':
                context = 'success';
                break;

            default:
                context = 'success';
            //
        }
        return context;
    }

    function getOrderStateIcon(code) {
        var icon = void 0;

        switch (code) {
            case 'READY':
                icon = 'ico-truck';
                break;
            case 'PICKEDUP':
                icon = 'ico-truck';
                break;
            case 'DEPOT':
                icon = 'ico-truck';
                break;
            case 'TRANSIT':
                icon = 'ico-truck';
                break;
            case 'DELIVERED':
                icon = 'ico-truck';
                break;
            case 'SIGNED':
                icon = 'ico-truck';
                break;

            default:
                icon = 'ico-truck';
            //
        }

        return icon;
    }

    function getRecentOrders() {
        var urlString = '/assets/data/packages.json';

        return $http.get(urlString).then(function (response) {
            return response.data.orders.results.slice(0, 2);
        });
    }

    function getOrders() {
        var urlString = '/assets/data/packages.json';

        return $http.get(urlString).then(function (response) {
            return response.data.orders.results;
        });
    }

    function validateContact(customerNumber, licenseNumber) {
        var urlString = '/assets/data/packages.json';

        return $http.get(urlString).then(function (response) {
            return response.data.contacts.find(function (i) {
                return i.customerNumber === customerNumber && i.licenseNumber === licenseNumber;
            });
        });
    }

    function getStateHistory(id) {
        ///api/pod/{id:int}/stateHistory 
        var urlString = '/assets/data/packages.json';

        return $http.get(urlString).then(function (response) {
            var stateHistory = void 0;
            stateHistory = response.data.stateHistory.find(function (i) {
                return i.id === id;
            });
            if (!stateHistory) {
                stateHistory = response.data.stateHistory.find(function (i) {
                    return i.id === 6;
                });
            }

            return stateHistory.stateHistory;
        });
    }

    function getOrderTypes() {
        ///api/pod/orderTypes 
        var urlString = '/assets/data/packages.json';
        return $http.get(urlString).then(function (response) {
            return response.data.orderTypes.results;
        });
    }

    function getPackageTypes() {
        ///api/pod/packageTypes 
        var urlString = '/assets/data/packages.json';
        return $http.get(urlString).then(function (response) {
            //return lodash.map(response.data.packages, i => PackageItem.create(i));
            return response.data.packageTypes.results;
        });
    }

    function getById(id) {
        var urlString = '/assets/data/packages.json';

        return $http.get(urlString).then(function (response) {
            var orders = response.data.orders.results;
            var order = _lodash2.default.find(orders, function (i) {
                return i.id === id;
            });

            if (!order) {
                order = _lodash2.default.find(orders, function (i) {
                    return i.id === 3;
                });
            }

            return order;
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/packagesService.js
// module id = 820
// module chunks = 0